export const MOBILE_SCREEN_WIDTH = 768;
export const TABLET_SCREEN_WIDTH = 1440;
